import React from 'react'
import { Box, ButtonBase, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import {
  Scale,
  GitCompare,
  Swords,
  FileSearch,
  FileDown,
  Link2,
} from 'lucide-react'

const CAPABILITIES = [
  { key: 'research_law',           Icon: Scale },
  { key: 'compare_jurisdictions',  Icon: GitCompare },
  { key: 'build_argument',         Icon: Swords },
  { key: 'analyze_document',       Icon: FileSearch },
  { key: 'draft_export',           Icon: FileDown },
  { key: 'find_citations',         Icon: Link2 },
]

const CapabilityChips = ({ onPick }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'

  const bg = isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)'
  const border = isDark ? 'rgba(255,255,255,0.10)' : 'rgba(0,0,0,0.10)'
  const hoverBorder = theme.palette.warning?.main || '#E6A23C'

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: 1,
        width: '100%',
        maxWidth: '620px',
        mb: { xs: 2, sm: 2.5 },
        px: 1,
      }}
    >
      {CAPABILITIES.map(({ key, Icon }) => {
        const label = t(`capability_${key}`)
        const prompt = t(`capability_${key}_prompt`)
        return (
          <ButtonBase
            key={key}
            onClick={() => onPick?.({ key, prompt })}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.75,
              height: 32,
              px: 1.5,
              borderRadius: '999px',
              backgroundColor: bg,
              border: `1px solid ${border}`,
              color: theme.palette.text.secondary,
              fontFamily: theme.typography.fontFamily,
              transition: 'all 0.15s ease',
              '&:hover': {
                borderColor: hoverBorder,
                color: theme.palette.text.primary,
                transform: 'translateY(-1px)',
              },
              '&:focus-visible': {
                outline: `2px solid ${hoverBorder}`,
                outlineOffset: 2,
              },
            }}
          >
            <Icon size={14} strokeWidth={2} />
            <Typography
              component="span"
              sx={{ fontSize: 13, fontWeight: 500, lineHeight: 1, whiteSpace: 'nowrap' }}
            >
              {label}
            </Typography>
          </ButtonBase>
        )
      })}
    </Box>
  )
}

export default CapabilityChips
